import { Typography } from "@mui/material";

import React from "react";
import { Box } from "@mui/material";

interface IDetailItemProps {
  label: string;
  value: string;
}

const DetailItem = ({ label, value }: IDetailItemProps) => {
  return (
    <Box className="flex flex-col gap-1">
      <Typography fontSize={14} color="gray.darker">
        {label}
      </Typography>
      <Typography fontSize={16} lineHeight={1.5} color="black.dark">
        {value}
      </Typography>
    </Box>
  );
};

export default DetailItem;
